import React, { useState } from "react";
import HeaderBar from "../../../components/header/headerBar";
import Select from "../../../components/select/select";
import DoctorTable from "./doctortable";
import WorkSchedule from "./workschedule";
import WorkerTable from "./workertable";

const BookingCalendar = () => {
  const [active, setActive] = useState(0);

  const option = [
    { value: "branch1", name: "เอกมัย" },
    { value: "branch2", name: "พระราม 9" },
    { value: "branch3", name: "ชิดลม" },
    { value: "branch4", name: "สาทร" },
  ];

  const tabList = [
    { title: "ตารางงาน/Work Schedule" },
    { title: "ตารางแพทย์/Doctor Schedule" },
    { title: "ตารางผู้ปฏิบัติงาน/Therapist Schedule" },
    { title: "เครื่องมือ/Equipment" },
  ];

  const getData = [
    {
      id: 1,
      title: "10",
      start: "2022-02-02",
      display: "background",
      color: "#5baea9",
      textColor: "#FFF",
    },
    {
      id: 2,
      title: "6",
      start: "2022-02-26",
      display: "background",
      color: "#5baea9",
      textColor: "#FFF",
    },
    {
      id: 3,
      title: "4",
      start: "2022-02-20",
      display: "background",
      color: "#5baea9",
      textColor: "#FFF",
    },
  ];

  const panelList = [
    { panel: <WorkSchedule /> },
    { panel: <DoctorTable /> },
    { panel: <WorkerTable data={getData} /> },
  ];

  const changeTab = (index: number) => {
    setActive(index);
  };

  return (
    <div>
      <HeaderBar title="BOOKING CALENDAR" />
      <div style={{ padding: "0px 20px" }}>
        <div className="row">
          <div className={"slect-booking"}>
            <div className="booking-selectCoin">
              <Select title="เลือกสาขา/Select Branch :" option={option} />
            </div>
            <div className={`tabs`}>
              {tabList?.map((child, index) => {
                return (
                  <div
                    className={`tabs-container ${active == index ? "active" : ""
                      } `}
                    key={index}
                    style={{
                      width : '250px',
                      padding: '2rem 1rem',
                      textAlign: 'center'
                    }
                    }
                    onClick={() => changeTab(index)}
                  >
                    {child.title}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div>{panelList[Number(active)].panel}</div>
      </div>
    </div>
  );
};
export default BookingCalendar;
